import { type FunctionComponent, type ReactElement } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';

import style from './ReadMoreButton.scss';

type Underline = 'none' | 'underline' | 'dashed';

type ReadMoreButtonProps = {
    isExpanded?: boolean;
    className?: string;
    underline?: Underline;
    onClick: () => void;
    readLessMessage: ReactElement;
    readMoreMessage: ReactElement;
};

export const ReadMoreButton: FunctionComponent<ReadMoreButtonProps> = ({
    isExpanded,
    className,
    underline = 'underline',
    onClick,
    readLessMessage,
    readMoreMessage,
}) => {
    const dataTn = isExpanded ? 'read-less' : 'read-more';

    return (
        <Link
            className={classnames(style.button, className)}
            underline={underline}
            onClick={onClick}
            dataTn={dataTn}
        >
            {isExpanded ? readLessMessage : readMoreMessage}
        </Link>
    );
};
